export default "__VITE_ASSET__JVyrqIjV__"